import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'hyphenate', standalone: true })
export class HyphenatePipe implements PipeTransform {
  static instance: HyphenatePipe;

  static transform(value: string): string {
    this.instance ||= new HyphenatePipe();

    return this.instance.transform(value);
  }

  public transform(value: string = null): string {
    if (!value) {
      return value;
    }

    return value.replaceAll('(-)', '&shy;');
  }
}
